import React,{ Component } from 'react';
import ReactDOM from 'react-dom';

class PopoverComponent extends Component{

    constructor(props){
        super(props);
    }

    componentDidMount(){
        //for bootstrap 4 ,popover to display tables,tables have to be disabled from gettting sanitized/disabled
        bootstrap.Popover.Default.allowList.table = [];
        bootstrap.Popover.Default.allowList.tr = [];
        bootstrap.Popover.Default.allowList.td = [];
        bootstrap.Popover.Default.allowList.div = [];
        bootstrap.Popover.Default.allowList.tbody = [];
        bootstrap.Popover.Default.allowList.thead = [];
        // if the page is Dashboard, popovers are disabled
        if(this.props.isDashboard){
            $('[data-toggle="popover"]').popover('disable');
        }
        else{
            jQuery('[data-toggle="popover"]').popover({
                template: '<div class="popover popover-header-primary" role="tooltip"><div class= "arrow" ></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
            });
        }
    }

    render(){
        let iconName = `${this.props.config.icon} pd-r-5`;
        let data_content = this.props.config.content;
        return(
            <a className={this.props.config.className} data-toggle="popover" data-placement={this.props.config.position} title={this.props.config.title} data-html='true' data-content={data_content} id={this.props.config.id}>
                {this.props.config.html_data}
            </a>   
        );
    }
}

export default PopoverComponent;

